import { Rocket } from "lucide-react";
import { useTranslation } from "react-i18next";
import { RouterNavLink } from "../../../components/RouterNavLink";

const QUICK_LINKS = [
  { to: "/pos", labelKey: "dashboard.getting_started_pos" },
  { to: "/sales", labelKey: "dashboard.getting_started_sales" },
  { to: "/purchases", labelKey: "dashboard.getting_started_purchases" },
  { to: "/inventory", labelKey: "dashboard.getting_started_inventory" },
] as const;

export function DashboardGettingStartedBanner() {
  const { t } = useTranslation();

  return (
    <section
      className="rounded-xl border border-dashed border-emerald-300 bg-emerald-50/60 p-4"
      aria-label={t("dashboard.getting_started_title")}
    >
      <div className="flex flex-wrap items-start gap-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-white text-emerald-700 shadow-sm">
          <Rocket className="h-5 w-5" aria-hidden="true" />
        </div>
        <div className="min-w-0 flex-1">
          <h2 className="text-sm font-bold text-emerald-950">
            {t("dashboard.getting_started_title")}
          </h2>
          <p className="mt-1 text-xs leading-relaxed text-emerald-900/80">
            {t("dashboard.getting_started_body")}
          </p>
          <div className="mt-3 flex flex-wrap gap-2">
            {QUICK_LINKS.map((link) => (
              <RouterNavLink
                key={link.to}
                to={link.to}
                className="rounded-lg bg-godo-accent px-3 py-1.5 text-xs font-semibold text-white hover:bg-emerald-600"
              >
                {t(link.labelKey)}
              </RouterNavLink>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
